import {
  Chart,

  // Controllers
  BarController,
  DoughnutController,
  LineController,

  // Elements
  BarElement,
  ArcElement,
  LineElement,
  PointElement,

  // Scales
  CategoryScale,
  LinearScale,

  // Plugins
  Tooltip,
  Legend,
  Colors,
} from "chart.js";

export default defineNuxtPlugin(() => {
  let registered = false;
  if (registered) {
    console.log("chart js already registered");
    return;
  }

  registered = true;

  Chart.register(
    BarController,
    DoughnutController,
    LineController,
    BarElement,
    ArcElement,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Colors,
    Legend,
    DoughnutController
  );
});
